import { cn } from '@/lib/utils';

/** Core field colors for list toolbars (see `app.css` `--list-controls-*`). */
export const listControlsInputColors =
    'border-[hsl(var(--list-controls-border))] bg-[hsl(var(--list-controls-surface))] text-[hsl(var(--list-controls-foreground))] placeholder:text-[hsl(var(--list-controls-placeholder))]';

/** Toolbar fields on hero lists (same tokens as solid; name kept for imports). */
export const listControlsGlassInput = listControlsInputColors;

export const listControlsGlassTrigger = cn(
    listControlsGlassInput,
    'data-placeholder:text-[hsl(var(--list-controls-placeholder))]',
);

export const listControlsGlassOutlineControl = cn(
    listControlsGlassInput,
    'hover:bg-[hsl(var(--list-controls-surface-hover))]',
);

export const listControlsSolidOutlineControl = cn(
    listControlsInputColors,
    'hover:bg-[hsl(var(--list-controls-surface-hover))]',
);

/** Footer row — background from `--list-controls-pagination-bg`. */
export const listControlsGlassPaginationBar =
    'border-t border-[hsl(var(--list-controls-border))] bg-[hsl(var(--list-controls-pagination-bg))] px-6 py-3';

export const listControlsGlassNavButton = cn(
    'flex items-center gap-1 rounded-md border px-3 py-1.5 text-sm transition-colors disabled:cursor-not-allowed disabled:opacity-50',
    'border-[hsl(var(--list-controls-border))] bg-[hsl(var(--list-controls-surface))]',
    'text-[hsl(var(--list-controls-muted-foreground))] hover:bg-[hsl(var(--list-controls-surface-hover))]',
);
